export const PageTitles = {
    SIGN_IN: "Login",
    SIGN_UP: "Sign Up",
    FORGOT_PASSWORD: "Forgot Password",
    VERIFICATION_CODE: "Verification Code"
  };